import { PrefType } from './type';

export const TXN_REG_PREF_FF = {
  prefEditDownloaded: 'prefEditDownloaded',
  prefDeleteDownloaded: 'prefDeleteDownloaded',
  prefAutoSaveEditedTxns: 'prefAutoSaveEditedTransactions',
  prefMoneyInOutColumn: 'prefMoneyInOutColumn',
  prefAutoSearch: 'prefAutoSearch',
  prefWrapText: 'prefWrapText',
  prefLongCatName: 'prefLongCatName',
  prefCurrencySymbolTxnList: 'prefCurrencySymbolTransactionList',
  prefNewTxnEntry: 'prefNewTransactionEntry',
  prefColoredAccounts: 'prefColoredAccounts',
  prefMultiEditAlert: 'prefMultiEditAlert',
};

export const preferenceData: PrefType[] = [
  {
    label: 'Allow editing amounts of downloaded transactions',
    field: 'editDownloaded',
    id: 'txn-pref-edit-downloaded-txns',
    fflag: TXN_REG_PREF_FF.prefEditDownloaded,
  },
  {
    label: 'Allow deletion of downloaded transactions',
    field: 'deleteDownloaded',
    id: 'txn-pref-delete-downloaded-txns',
    fflag: TXN_REG_PREF_FF.prefDeleteDownloaded,
  },
  {
    label: 'Automatically save edited transactions',
    field: 'autoSave',
    id: 'txn-pref-auto-save-edited-txns',
    fflag: TXN_REG_PREF_FF.prefAutoSaveEditedTxns,
  },
  {
    label: 'Show separate Money In and Money Out columns',
    field: 'doubleAmounts',
    id: 'txn-pref-show-money-in-money-out',
    fflag: TXN_REG_PREF_FF.prefMoneyInOutColumn,
  },
  {
    label: 'Automatically search in register as you type in search field',
    field: 'autoSearch',
    id: 'txn-pref-auto-search',
    fflag: TXN_REG_PREF_FF.prefAutoSearch,

  },
  {
    label: 'Wrap text in transaction list fields',
    field: 'wrapText',
    id: 'txn-pref-wrap-text-in-txn-field',
    fflag: TXN_REG_PREF_FF.prefWrapText,
  },
  {
    label: 'Show long form of category names (show full path with parent names)',
    field: 'longCats',
    id: 'txn-pref-show-long-category-names',
    fflag: TXN_REG_PREF_FF.prefLongCatName,
  },
  {
    label: 'Show currency symbol on amounts in the transaction list',
    field: 'showCurrencySymbol',
    id: 'txn-pref-show-currency-symbol-on-amounts',
    fflag: TXN_REG_PREF_FF.prefCurrencySymbolTxnList,
  },
  {
    label: 'After adding a new transaction include new transaction entry above all existing transactions',
    field: 'continuousCreate',
    id: 'txn-pref-new-txn-entry-above-txns',
    fflag: TXN_REG_PREF_FF.prefNewTxnEntry,
  },
  {
    label: 'Show colored icon in transaction list instead of full account name',
    field: 'showAccountColors',
    id: 'txn-pref-show-account-colors',
    fflag: TXN_REG_PREF_FF.prefColoredAccounts,
  },
  {
    label: 'Show alert when saving changes to multiple transactions',
    field: 'showMultiEditAlert',
    id: 'txn-pref-show-multi-edit-alert',
    fflag: TXN_REG_PREF_FF.prefMultiEditAlert,
  },
];
